import { useNavigate } from 'react-router-dom';

import { CollectionComponentTypeForm } from '../components/CollectionComponentTypeForm';

export const CreateCollectionComponentTypesCollectionComponentTypePage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10">
      <div>
        <CollectionComponentTypeForm
          type="Create"
          onSubmit={async (collectionComponentTypeId) => {
            navigate(`/collection-component-types`);
          }}
          onCancel={() => {
            navigate(`/collection-component-types`);
          }}
        />
      </div>
    </div>
  );
};
